import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Fac from 'Icons/Fac';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';

const useStyles = buildUseStyles('Progress', ((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
  },
})));

const Progress = ({ totalSteps, currentStepIdx }) => {
  const classes = useStyles();

  if (totalSteps === 1) {
    return null;
  }

  return (
    <Box
      className={classes.root}
    >
      {_.range(totalSteps).map(stepIdx => (
        <Icon
          key={stepIdx}
          icon={Fac}
          fill={stepIdx === currentStepIdx ? 'orange' : 'mediumGray'}
          boxSize={'xxs'}
        />
      ))}
    </Box>
  );
};

Progress.propTypes = {
  totalSteps: PropTypes.number.isRequired,
  currentStepIdx: PropTypes.number.isRequired,
};

export default Progress;
